export default {
  path: "/user/cpa/material-grafico",
  component: () =>
    import("@/views/user/cpa/material-grafico/MaterialGraficoLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      redirect: { name: "material-grafico-credenciales" },
    },
    {
      path: "credenciales",
      name: "material-grafico-credenciales",
      component: () =>
        import("@/views/user/cpa/material-grafico/CredencialesView.vue"),
    },
  ],
};
